var map = {
	"./1.jpg": 2490,
	"./10.jpg": 4792,
	"./11.jpg": 8309,
	"./13.jpg": 9543,
	"./14.jpg": 8348,
	"./15.jpg": 6393,
	"./2.jpg": 8213,
	"./3.jpg": 3896,
	"./4.jpg": 6987,
	"./5.jpg": 8942,
	"./6.jpg": 2857,
	"./7.jpg": 2332,
	"./8.jpg": 79,
	"./9.jpg": 8370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8792;